import { render } from "./ChoiceType.vue?vue&type=template&id=128bba5f"
import script from "./ChoiceType.vue?vue&type=script&lang=js"
export * from "./ChoiceType.vue?vue&type=script&lang=js"

import exportComponent from "/home/jeim2750/fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__